import type { FC } from "react";

import { useForkStatus } from "../context";
import { PausedForkStatusRoute } from "./PausedForkStatusRoute";
import { UnpausedForkStatusRoute } from "./UnpausedForkStatusRoute";

export const ForkStatusRoute: FC = () => {
  const fork = useForkStatus();
  if (fork.paused) {
    return <PausedForkStatusRoute fork={fork} />;
  }
  return <UnpausedForkStatusRoute fork={fork} />;
};
